import React, { useState } from "react";
import { Collapse, Table, Button, Select, Upload } from "antd";
const ServiceManagement = () => {
  const [labTestServicesData, setlabTestServicesData] = useState([
    {
      key: 1,
      servicename: "CBC",
      price: 400,
      discount: "40 %",
      status: "Available",
    },
    {
      key: 2,
      servicename: "LFT",
      price: 400,
      discount: "40 %",
      status: "Available",
    },
    {
      key: 3,
      servicename: "KFT",
      price: 400,
      discount: "40 %",
      status: "Unavailable",
    },
    {
      key: 4,
      servicename: "HBSAG",
      price: 400,
      discount: "40 %",
      status: "Unavailable",
    },
  ]);

  const labTestColumns = [
    {
      title: "Service Name",
      dataIndex: "servicename",
      key: "servicename",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Discount %",
      dataIndex: "discount",
      key: "discount",
    },
    {
      title: "Final Price",
      dataIndex: "final_price",
      key: "final_price",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Button
            type="primary"
            disabled={record.status === "Unavailable"} // Disable if status is "Unavailable"
            // onClick={() => handleAdd(record)}
          >
            Add
          </Button>
          <Button
            type="primary"
            danger
            disabled={record.status === "Available"} // Disable if status is "Unavailable"
            // onClick={() => handleRemove(record)}
          >
            Remove
          </Button>
        </div>
      ),
    },
  ];
  return (
    <div>
      <Table
        columns={labTestColumns}
        dataSource={labTestServicesData}
        pagination={false} // Disable pagination
      />
    </div>
  );
};

export default ServiceManagement;
